const editElementInStructure = (el, sourceArray, level = 0) => {
  const arrayToReturn = sourceArray;
  const index = parseInt(el?.id[level], 10);

  if (Array.isArray(sourceArray[index])) {
    arrayToReturn[index] = editElementInStructure(
      el,
      arrayToReturn[index],
      level + 1
    );

    return arrayToReturn;
  }
  if (['container', 'row'].includes(sourceArray[index]?.type)) {
    arrayToReturn[index] = sourceArray[index];
    arrayToReturn[index].elements = editElementInStructure(
      el,
      arrayToReturn[index].elements,
      level + 1
    );
  }
  if (!['container', 'row'].includes(sourceArray[index]?.type))
    arrayToReturn[index] = el;

  return arrayToReturn;
};

export default editElementInStructure;
